import { TsDOM as q, throttle } from '@/scripts/core/TsDOM'
import { ProductForm } from '@/scripts/product/product-form'
import { ProductInfo } from '@/scripts/product/product-info'
import { ProductModal } from '@/scripts/product/product-modal'
import { MediaGallery } from '@/scripts/product/media-gallery'
import { VariantSelects } from '@/scripts/theme/variant-selects'
import { VariantRadios } from '@/scripts/theme/variant-radios'
import { ProductRecommendations } from '@/scripts/theme/product-recommendations'
import { KlaviyoWaitlistInline } from '@/scripts/product/klaviyo-waitlist-inline'
import MainGallery from '@/scripts/product/main-gallery'
import SpecificationAccordion from '@/scripts/product/specification-tab'
import '@/scripts/core/cart-attribution'

q.safeDefineElement(ProductInfo)
q.safeDefineElement(ProductForm)
q.safeDefineElement(ProductModal)
q.safeDefineElement(MediaGallery)
q.safeDefineElement(VariantSelects)
q.safeDefineElement(VariantRadios)
q.safeDefineElement(ProductRecommendations)
q.safeDefineElement(KlaviyoWaitlistInline)

document.addEventListener('DOMContentLoaded', () => {
	new MainGallery()
	SpecificationAccordion()


	// const stikcyAddToCart = document.querySelector('.product__sticky-atc');
	//
	// if( stikcyAddToCart ) {
	// 	const footer = document.querySelector('.footer');
	//
	// 	function isFooterVisible() {
	// 		if (!footer) return false;
	// 		const footerRect = footer.getBoundingClientRect();
	// 		return footerRect.top < window.innerHeight;
	// 	}
	//
	// 	window.addEventListener('scroll', throttle(() => {
	// 		if (isFooterVisible()) {
	// 			stikcyAddToCart?.classList.add('is-hidden');
	// 		} else {
	// 			stikcyAddToCart?.classList.remove('is-hidden');
	// 		}
	// 	}, 200));
	// }
})
